import { Navigate, Route, Routes } from 'react-router-dom';
import AnalyticsDashboardPage from './AnalyticsDashboardPage';
import ReportsPage from './ReportsPage';
import AudiencePage from './AudiencePage';
import ExportsPage from './ExportsPage';

export default function AnalyticsRoutes() {
  return (
    <Routes>
      <Route index element={<AnalyticsDashboardPage />} />
      <Route path="reports" element={<ReportsPage />} />
      <Route path="audience" element={<AudiencePage />} />
      <Route path="exports" element={<ExportsPage />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
